import { render } from "./FormViewer.vue?vue&type=template&id=652b68f5&scoped=true&ts=true"
import script from "./FormViewer.vue?vue&type=script&lang=ts"
export * from "./FormViewer.vue?vue&type=script&lang=ts"

import "./FormViewer.vue?vue&type=style&index=0&id=652b68f5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652b68f5"]])

export default __exports__